import { render } from "./EscrowAccountBankStyle.vue?vue&type=template&id=05050cca&scoped=true"
import script from "./EscrowAccountBankStyle.vue?vue&type=script&lang=js"
export * from "./EscrowAccountBankStyle.vue?vue&type=script&lang=js"

import "./EscrowAccountBankStyle.vue?vue&type=style&index=0&id=05050cca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05050cca"]])

export default __exports__